import { render, staticRenderFns } from "./chart_pie.vue?vue&type=template&id=24656fd2"
import script from "./chart_pie.vue?vue&type=script&lang=js"
export * from "./chart_pie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports